module.exports = __webpack_public_path__ + "static/media/ico_mobile.e47dde7f.jpg";